import { ClientOnly } from '@components/shared/ClientOnly';
import { formatDate } from '@utils/dates';
import MoreOrLess from '@xo-union/tk-component-more-or-less';
import classNames from 'classnames';
import React, { type FC, useMemo, memo } from 'react';
import Styles from './styles.scss';

export interface Props {
	vendorName: string | null;
	createdDate?: string | null;
	text?: string | null;
	minimize?: boolean | null;
}

const VendorReply: FC<Props> = memo(
	({ createdDate, text, vendorName, minimize }) => {
		const dateFormatted = useMemo(() => {
			if (!createdDate) {
				return '';
			}

			return formatDate(createdDate, 'MM/dd/yyyy') ?? '';
		}, [createdDate]);

		if (!text) {
			return null;
		}

		return (
			<div
				className={Styles.commentWrapper}
				data-testid="vendor-reply-component"
			>
				<div className={Styles.headingWrapper}>
					Response from {vendorName}
					<ClientOnly> on {dateFormatted}</ClientOnly>
				</div>
				<MoreOrLess
					className={classNames({
						[Styles.commentBody]: !minimize,
						[Styles.commentBodyMinimize]: minimize,
					})}
					content={text}
					charLimit={minimize ? 90 : 244}
				/>
			</div>
		);
	},
);

export default VendorReply;
